export default "__VITE_ASSET__DOBpDrCm__"